// 2024-03-28 switched from cscs to proj4
// DO NOT USE ol method geom.getLength() or geom.getArea() with epsg:3857 because it's cartesian
// ol does provide spherical lengths and areas with getLength(geom) and getArea(geom) which require:
// import {getArea, getLength} from '../node_modules/ol/sphere.js';

import formatDist from './util/formatDist.js';
import bearing from './util/bearing.js';

/**
 * Inverse (bearing & distance) between the last two points of LineString
 * @param {ol.geom.LineString} An ol3 line
 * @return {string} bearing and distance
 * called only in Tooltip.js
 */

export default function(line) {
  let out = ''
  let cartesian = rwg.proj.cartesianSRID

  if (cartesian) {
    const map = rwg.proj.mapSRID
    let vertices = line.getCoordinates();
    let verticesLength  = vertices.length;
    let p1 = rwg.proj.transform(map, cartesian, vertices[verticesLength - 2]); // next to last vertex of line
    let p2 = rwg.proj.transform(map, cartesian, vertices[verticesLength - 1]); // last vertex of line
    let dx = p2[0] - p1[0];
    let dy = p2[1] - p1[1];
    let distance = Math.hypot(dx, dy);
    if (distance > 0.01) {
      if (rwg.proj.cartesianMetersPerUnit === 1) {
        distance = distance * 3.28084
      }
      out = bearing(dx, dy) + formatDist(distance);
    }
  } // else rwg.proj.cartesianSRID not set

  return out;
}
